/**
 * Simple background fader
 *
 * Loops throught .main-image .image elements
 * and blends them after each other
 *
 * @author Mario Klug <mario.klug@sourcefactory.at>
 */
var BackgroundFader = (function() {

    this.defaults = {
        duration: 3000,
        timeout: 5000
    };

    this.duration = 0;
    this.timeout  = 0;

    this.images  = [];
    this.current = 0;
    this.last    = 0;

    this.interval = null;

    this.init = function(config) {

        config = config || {};

        duration = config.duration || defaults.duration;
        timeout  = config.timeout  || defaults.timeout;

        images = $('.main-image .image');

        if ($(images).length > 0) {

            $('.main-image').css({
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                'z-index': -1
            });

            $('.main-image .image').css({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                'z-index': -1
            }).hide();
        }

        if ($(images).length > 0) {

            $(images[0]).show();
        }

        if ($(images).length > 1) {

            $(images[1]).css('z-index', 1).hide();

            window.setTimeout(function() {

                fadeToNext();
            }, timeout);
        }
    };

    this.fadeToNext = function() {

        last = current;
        current ++;

        if (current >= images.length) {

            current = 0;
        }

        var newImage = images[current];
        var obj = this;

        $(newImage).css('z-index', '1');
        $(newImage).fadeIn(duration, function() {

            var last    = obj.images[obj.last];
            var current = obj.images[obj.current];

            $(last).hide();
            $(last).css('z-index', '-1');
            $(current).css('z-index', '0');

            window.setTimeout(function() {

                fadeToNext();
            }, timeout);
        });
    };

    return {
        init: this.init
    };
})();

window.BackgroundFader = BackgroundFader
